import { useEffect } from 'react';
import {
    AVAILABILITY_STATUS_URI_PARAM,
    INTERESTS_STATUS_URI_PARAM,
    USER_AVAILABILITY,
    USER_INTEREST,
} from './config';

export const useEditInfoRequestFromUriParam = ({
    setRemoveParamsOnModalClose,
    handleEditSection,
    setModalParams,
    parsedParams,
}) => {
    /**
     * open edit avail.status modal in
     * case e.g. if a user is redirected
     * to his profile from email
     */
    const availabilityStatusChange = parsedParams && parsedParams[AVAILABILITY_STATUS_URI_PARAM];
    const interestsStatusChange = parsedParams && parsedParams[INTERESTS_STATUS_URI_PARAM];

    const getParamsForModal = () => {
        if (availabilityStatusChange) {
            return { isConfirm: true };
        }

        return {};
    };

    const getEditSectionTargetName = () => {
        if (availabilityStatusChange) return USER_AVAILABILITY;
        if (interestsStatusChange) return USER_INTEREST;
    };

    const targetUriParam = availabilityStatusChange || interestsStatusChange;

    useEffect(() => {
        if (!targetUriParam) return;

        setModalParams(getParamsForModal());

        handleEditSection(getEditSectionTargetName());
        setRemoveParamsOnModalClose(true);
    }, [targetUriParam]);
};
